import { render, staticRenderFns } from "./understandingText.vue?vue&type=template&id=4cd5153c&"
import script from "./understandingText.vue?vue&type=script&lang=js&"
export * from "./understandingText.vue?vue&type=script&lang=js&"
import style0 from "./understandingText.vue?vue&type=style&index=0&id=4cd5153c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports